<template>
  <div class="create-header">
    <div class="create-header-content">
      <div
        class="go-back"
        @click="goBack"
      >
        <mk-iconfont
          icon-class="left"
          class="icon"
        />
        <span class="txt">返回</span>
      </div>
      <h3>{{ title }}</h3>
    </div>
    <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      v-bind="confirmDialogData"
      append-to-body
      @on-confirm="onConfirm"
    />
    <slot />
  </div>
</template>
<script>
export default {
  name: 'CreateHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    backTxt: {
      type: String,
      default: '内容不会被保存'
    },
    needBackTxt: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      confirmDialogData: {
        title: '返回提示',
        tip: this.backTxt,
        iconColor: '#fa8c15',
        iconClass: 'tishi-info',
        closeBtn: {
          type: 'default',
          color: '#595959',
          text: '取 消',
          isShow: true
        },
        confirmBtn: {
          type: 'primary',
          color: '#fff',
          text: '确认',
          isShow: true
        }
      },
      isShowConfirmDialog: false,
      needEmit: false // 需要回传事件的
    }
  },
  deactivated () {
    this.isShowConfirmDialog = false
  },
  methods: {
    goBack () {
      this.needEmit = false
      if (this.needBackTxt) {
        this.confirmDialogData = {
          title: '返回提示',
          tip: this.backTxt,
          iconColor: '#fa8c15',
          iconClass: 'tishi-info',
          closeBtn: {
            type: 'default',
            color: '#595959',
            text: '取 消',
            isShow: true
          },
          confirmBtn: {
            type: 'primary',
            color: '#fff',
            text: '确认',
            isShow: true
          }
        }
        this.isShowConfirmDialog = true
      } else {
        history.go(-1)
      }
    },
    onConfirm () {
      if (this.needEmit) {
        this.$emit('othter-click')
      } else {
        history.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .create-header {
    min-height: 60px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 1px 0 0 rgba(232, 232, 232, 1);
    border-radius: 2px 2px 0 0;

    .create-header-content {
      display: flex;
      align-items: center;

      .go-back {
        cursor: pointer;
        margin-left: 20px;
        // font-weight: 500;
        font-weight: 500;
        line-height: 16px;
        display: flex;
        align-items: center;

        .icon {
          font-size: 18px;
          color: #000;
        }

        .txt {
          font-size: 16px;
          color: #262626;
        }

        // &:hover {
        //   opacity: 0.8;
        // }
      }

      h3 {
        font-size: 16px;
        line-height: 16px;
        margin-left: 24px;
        color: #262626;
      }
    }
  }
</style>
